module.exports = __webpack_public_path__ + "img/qu.d948422e.png";